export default __webpack_public_path__ + "6df05c03e777fdac1d4ceb929f0d7a0a.woff";